import appConstants from '../../../../constants';
import { KEYS } from '../../../../l18n/constants';
import computeClassName from '../../../../utils/computeClassName';
import { useL18nContext } from '../../ContextProvider/L18n';

const constants = Object.freeze({
  CLASSNAME_BASE: 'text-cc-body-small xs:text-cc-body-medium text-cc-secondary-contrast',
  PARTNER_SPECIALIZATIONS_DEFAULT: [],
  SELECTED_PARTNER_ROLE_CODE_DEFAULT: null
})

const propsDefaults = Object.freeze({
  partnerSpecializations: constants.PARTNER_SPECIALIZATIONS_DEFAULT,
  selectedPartnerRoleCode: constants.SELECTED_PARTNER_ROLE_CODE_DEFAULT
});

function getComputedClassName(propsClassName) {
  return computeClassName(propsClassName, constants.CLASSNAME_BASE);
}

function computePartnerSpecializationCountAndLabels(partnerSpecializations, getTranslationFor) {
  let integratorSpecializationCount = 0;
  let providerCiscoPoweredServiceCount = 0;

  partnerSpecializations.forEach(
    specialization => {
      if (
        (specialization[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES) &&
        !appConstants.PROVIDER_LEVELS.includes(specialization[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim().toLowerCase())
      ) {
        providerCiscoPoweredServiceCount++;
      } else {
        if ((specialization[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_SPECIALIZATIONS) || (specialization[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_PARTNER_SPECIALIZATIONS)) {
          integratorSpecializationCount++;
        }
      }
    }
  );

  return {
    integratorSpecializationCount: integratorSpecializationCount,
    integratorSpecializationLabel: integratorSpecializationCount > 1 ? getTranslationFor(KEYS.L18N_KEY_LABEL_SPECIALIZATIONS) : getTranslationFor(KEYS.L18N_KEY_LABEL_SPECIALIZATION),
    providerCiscoPoweredServiceCount: providerCiscoPoweredServiceCount,
    providerCiscoPoweredServiceLabel: providerCiscoPoweredServiceCount > 1 ? getTranslationFor(KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES) : getTranslationFor(KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE),
    expertiseCount: integratorSpecializationCount + providerCiscoPoweredServiceCount,
    expertiseLabel: integratorSpecializationCount > 1 ? getTranslationFor(KEYS.L18N_KEY_LABEL_EXPERTISES) : getTranslationFor(KEYS.L18N_KEY_LABEL_EXPERTISE)
  };

}


export default function PartnerSpecializationCount(
  {
    partnerSpecializations = propsDefaults.partnerSpecializations,
    selectedPartnerRoleCode = propsDefaults.selectedPartnerRoleCode,
    className = ''
  }) {
  const computedClassName = getComputedClassName(className);
  const { getTranslationFor } = useL18nContext();
  const computedSpecializationCountAndLabels = computePartnerSpecializationCountAndLabels(partnerSpecializations, getTranslationFor);
  return (
    <p className={computedClassName}>
      {
        (computedSpecializationCountAndLabels.expertiseCount === 0) &&
        <>&nbsp;</>
      }
      {
        !selectedPartnerRoleCode &&
        (computedSpecializationCountAndLabels.expertiseCount > 0) &&
        <><span className="font-normal">{computedSpecializationCountAndLabels.expertiseCount}</span> {computedSpecializationCountAndLabels.expertiseLabel}</>
      }


      {
        !!selectedPartnerRoleCode &&
        (selectedPartnerRoleCode === appConstants.VALUE_INTEGRATOR) &&
        computedSpecializationCountAndLabels.integratorSpecializationCount > 0 &&
        <><span className="font-normal">{computedSpecializationCountAndLabels.integratorSpecializationCount}</span> {computedSpecializationCountAndLabels.integratorSpecializationLabel}</>
      }
      {
        !!selectedPartnerRoleCode &&
        (selectedPartnerRoleCode === appConstants.VALUE_INTEGRATOR) &&
        computedSpecializationCountAndLabels.integratorSpecializationCount === 0 &&
        <>&nbsp;</>
      }


      {
        !!selectedPartnerRoleCode && (selectedPartnerRoleCode === appConstants.VALUE_PROVIDER) &&
        computedSpecializationCountAndLabels.providerCiscoPoweredServiceCount > 0 &&
        <><span className="font-normal">{computedSpecializationCountAndLabels.providerCiscoPoweredServiceCount}</span> {computedSpecializationCountAndLabels.providerCiscoPoweredServiceLabel}</>
      }
      {
        !!selectedPartnerRoleCode && (selectedPartnerRoleCode === appConstants.VALUE_PROVIDER) &&
        computedSpecializationCountAndLabels.providerCiscoPoweredServiceCount === 0 &&
        <>&nbsp;</>
      }

      {
        !!selectedPartnerRoleCode && (![appConstants.VALUE_INTEGRATOR,appConstants.VALUE_PROVIDER].includes(selectedPartnerRoleCode)) &&
        <>&nbsp;</>
      }
    </p>
  );
}
